import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from "react-redux";
import {FormattedMessage, injectIntl} from "react-intl";

import {reorder} from "../../../misc/utils";
import Analytics from "../../../analytics";
import {getCurrentLayout} from "../../appLayout";
import {BACKSPLASH_TYPES} from "../../kvComponent/core/constants";
import CenterIsland from "../core/parts/centerIsland";
import {getFeatureGroupName} from "../../../misc/helpers";

class ContextMenuSimple extends Component {

  static propTypes = {
    contextMenuOpen: PropTypes.string.isRequired,
    hoveredLayer: PropTypes.object,
    handleContextMenuClick: PropTypes.func,
    contextMenuPosition: PropTypes.object,
    contextMenuPonyWall: PropTypes.bool,
    renderGreenLayerByZindex: PropTypes.func,
    closeContextMenu: PropTypes.func,
  };

  state = {
    contextMenuButtons: []
  };

  componentDidMount() {
    this.setContextMenuButtons();
    if (this.props.closeContextMenu) {
      document.addEventListener('click', this.contextMenuBlur)
    }
  }

  contextMenuBlur = (e) => {
    if (!e.target.closest('.contextmenu-buttons')
      && !e.target.closest('.contextmenu-buttons__button')
      && !e.target.closest('.sprocket-container') && !e.target.closest('.canvas')) {
      this.props.closeContextMenu();
    }
  };

  componentWillUnmount() {
    if (this.props.closeContextMenu) {
      document.removeEventListener('click', this.contextMenuBlur)
    }
  }

  setContextMenuButtons() {
    const layout = getCurrentLayout();
    const contextMenuOpen = this.props.contextMenuOpen;
    if (contextMenuOpen === "backsplash_custom"
      || contextMenuOpen === "backsplash_custom_left"
      || contextMenuOpen === "backsplash_custom_right"
      || contextMenuOpen === "right_wall_custom"
      || contextMenuOpen === "left_wall_custom") {
      this.setBacksplashButtons();
      return
    }

    const hoveredParent = layout.designNavigationItems().find(navItem => {
      return navItem.text === contextMenuOpen
    });

    let relatedItems = hoveredParent.part.relatedItems;

    const clickedItem = relatedItems.find((item) => {
      return item.activeFeature && (item.partId === this.props.hoveredLayer.partId)
    });

    let itemsToRender = this.getItemsToRender(hoveredParent);

    // console.log('clickedItem', clickedItem);
    // console.log('relatedItems', relatedItems);
    // console.log('itemsToRender', itemsToRender);

    const clickedItemIndex = itemsToRender.findIndex(item => item.text === clickedItem.partName);
    if (clickedItemIndex > 0) {
      itemsToRender = reorder(itemsToRender, clickedItemIndex, 0); // swap items in array start
    }

    itemsToRender = itemsToRender.map(item => {
      if (item.text === CenterIsland.id) {
        // item.subMenuText = "Countertop";
        item.bgImageText = "Countertop";
      }
      return item
    });

    this.setState({
      contextMenuButtons: itemsToRender
    })
  }

  getItemsToRender = (hoveredParent) => {
    let itemsToRender = hoveredParent.part.subParts();
    let availablePartIds = [];
    switch (this.props.contextMenuOpen) {
      case CenterIsland.id:
        availablePartIds = ["center_island_sink", "center_island_faucet", "center_island_countertop",
          "center_island_stovetop", "center_island_range", "center_island_edge"];
        break;
      case "Countertop":
        availablePartIds = ["countertop", "faucet", "sink", "edge_profile"];
        break;
      case "Walls":
        availablePartIds = ["right_wall", "backsplash"];
        break;
      default:
        break;
    }
    return itemsToRender.filter(menuButton => {
      if ((document.kvConfig.visualizerType === "kvScene") && (menuButton.part.partId === "center_island_edge")) {
        const layout = getCurrentLayout();
        if (layout.type === 3) {
          return false
        }
      }
      if ((document.kvConfig.visualizerType === "kvScene") && (menuButton.part.partId === "center_island_stovetop")) {
        const layout = getCurrentLayout();
        if (layout.type === 6) {
          return false
        }
      }
      // return availablePartIds.includes(menuButton.part.partId) && hoveredParent.part.layout.hasNavItemsLength(menuButton)
      return availablePartIds.includes(menuButton.part.partId)
    });
  };

  getBackSplashButtons = () => {
    return BACKSPLASH_TYPES.map(bType => {
      const button = {
        text: bType,
      };
      switch (bType) {
        case "4in":
          button.subMenuText = "visualizer.kitchen.contextmenu.backsplash.4in"
          break;
        case "6in":
          button.subMenuText = "visualizer.kitchen.contextmenu.backsplash.6in"
          break;
        case "Full":
          button.subMenuText = "visualizer.kitchen.contextmenu.backsplash.18in"
          break;
      }
      return button
    })
  };

  setBacksplashButtons = () => {
    const layout = getCurrentLayout();
    const hoveredParent = layout.designNavigationItems().find(navItem => {
      return navItem.text === "Walls"
    });
    const subParts = hoveredParent.part.subParts();

    let contextMenuButtons = [];
    const backSplashButtons = this.getBackSplashButtons();
    const rightWall = subParts.find(menuButton => menuButton.part.partId === "right_wall");
    const leftWall = subParts.find(menuButton => menuButton.part.partId === "left_wall");
    if (rightWall) {
      rightWall.subMenuParent = "Walls";
    }
    if (leftWall) {
      leftWall.subMenuParent = "Walls";
    }
    switch (this.props.contextMenuOpen) {
      case "right_wall_custom": {
        contextMenuButtons = rightWall ? [rightWall, ...backSplashButtons] : backSplashButtons;
        break;
      }
      case "left_wall_custom": {
        contextMenuButtons = leftWall ? [leftWall, ...backSplashButtons] : backSplashButtons;
        break;
      }
      case "backsplash_custom_left": {
        contextMenuButtons = [...backSplashButtons, leftWall];
        break;
      }
      case "backsplash_custom_right": {
        contextMenuButtons = [...backSplashButtons, rightWall];
        break;
      }
      case "backsplash_custom": {
        contextMenuButtons = backSplashButtons;  // just in case, we should not have these cases
        break;
      }
    }
    this.setState({
      contextMenuButtons
    })
  };

  handleContextMenuHover = () => {
    //TODO[Artem] add here rendering green zones on hover
  };

  render() {

    let contextMenuStyles = this.props.contextMenuPosition || {};
    if (this.state.contextMenuButtons.length <= 4) {
      contextMenuStyles = Object.assign({}, contextMenuStyles, {maxWidth:"210px"} )
    }

    const {intl, fabricatorData} = this.props;

    return (
      <div className="contextmenu" style={contextMenuStyles}>
        <div className="contextmenu-buttons">
          {this.state.contextMenuButtons.map((menuItem) => {
            if (!menuItem) {
              return null
            }
            return (
              <button key={menuItem.text}
                      onClick={() => {
                        Analytics.sendClickEvent('context-menu-' + menuItem.text);
                        this.props.handleContextMenuClick(menuItem);
                      }}
                      data-parent={this.props.contextMenuOpen}
                      onMouseOver={this.props.renderGreenLayerByZindex ? () => this.handleContextMenuHover(menuItem) : () => {}}
                      className={"contextmenu-buttons__button contextmenu-buttons__button--"
                      +(menuItem.bgImageText || menuItem.text).toLowerCase().replace(/ /g,"-")}>
                <span className="contextmenu-buttons__button-text">
                  {menuItem.subMenuText
                    ? <FormattedMessage id={menuItem.subMenuText || menuItem.part.translateId}/>
                    : getFeatureGroupName(menuItem.part, intl, fabricatorData)}
                </span>
              </button>
            )
          })}
        </div>
      </div>
    )
  }
}

const mapStateToProps = (store) => {
  return {
    fabricatorData: store.fabricatorState,
  };
};

const mapDispatchToProps = {};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(ContextMenuSimple)
)
